import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as scoreCardAPI from 'api/Scorecard';
import { extraFilterSmoothMerge } from 'utils/Sidebar';
import { /*generateDefaultLobTeamAgentAsSelected,*/ objectToArray, sortByPriorityIndex } from 'utils/redux';
import { validateErrorAndCheckArray } from 'utils/validation';

const initialState = {
  status: 'init',
  data: null,
  ScoreCardFilterConfigData: null,
  features_filter: null,
  LOB: null,
  LOBTeam: null,
  searchText: null,
  LOBTeamAgent: null,
  rangeDate: null,
  column: null,
  fields: {},
  selected: {
    LOB: [],
    LOBTeam: [],
    LOBTeamAgent: [],
    fields: {},
    rowFilter: {
      LOB: false,
      LOBTeam: false,
      LOBTeamAgent: false
    }
  },
  ui: {
    LOB: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeam: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeamAgent: {
      status: '',
      loading: false
    },
    loading: false
  },
  error: null,
  TeamColumnData: null
};
const getFilterState = (state) => state.filter;
const getScoreCardConfigData = createAsyncThunk('scorecardFilter/getScoreCardConfigData', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await scoreCardAPI.getScoreCardConfigData(params);
    const data = res?.data?.data;
    if (data) {
      let extra_filter = {};
      if (data.advancefilter) {
        for (const key in data.advancefilter.features_data) {
          extra_filter[key] = {
            slug: key,
            ...data.advancefilter.features_data[key]
          };
        }

        extra_filter = sortByPriorityIndex(extra_filter);
      } else {
        extra_filter = null;
      }
      let feature_filter = {};
      let fields = {};
      if (data.addcolumn) {
        for (const key in data?.addcolumn?.features_data) {
          fields[key] = objectToArray(data?.addcolumn?.features_data[key]);
        }
        dispatch(setFieldsData(fields));
      } else {
        fields = null;
      }
      console.log(feature_filter, 'feature_filter');
      return {
        ...data,
        data: {
          extra_filter: extra_filter,
          feature_filter: feature_filter
          // table_data: [tabledata]
        }
      };
    }
    return null;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getReportingTeamColumnData = createAsyncThunk('scorecardFilter/getReportingTeamColumnData', async (params, { rejectWithValue }) => {
  try {
    const res = await scoreCardAPI.getReportingTeamColumnData(params);
    const result = res.data?.data;
    // Build every group the API returns (e.g. "Skills & Core Parameters", "Sentiments"),
    // same shape the config loader produces, instead of a hardcoded "Features" group.
    const fields = {};
    if (result?.addcolumn?.features_data) {
      for (const key in result.addcolumn.features_data) {
        fields[key] = objectToArray(result.addcolumn.features_data[key]);
      }
    }
    return fields;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const filterSlice = createSlice({
  name: 'scorecardFilter',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },

    setSelectedDatafromParent: (state, action) => {
      if (action.payload) {
        if (state.data?.extra_filter)
          state.data.extra_filter = extraFilterSmoothMerge(state.data?.extra_filter, action.payload.parentFilters?.extra_filter);
        state.extra_filter = action.payload.parentFilters?.extra_filter;
        state.selected = action.payload.parentFilters?.selected;
        state.LOB = action.payload.parentFilters?.LOB;
        state.LOBTeam = action.payload.parentFilters?.LOBTeam;
        state.rangeDate = action.payload.parentFilters.rangeDate;
        state.LOBTeamAgent = action.payload.parentFilters?.LOBTeamAgent;
      }
    },
    setDefaultLobTeamAgent: (state, action) => {
      const {
        LOB,
        LOBTeam,
        LOBTeamAgent
        // selectedLOB,
        // selectedLOBTeam,
        // selectedLOBTeamAgent,
      } = action.payload;
      state.LOB = LOB;
      state.LOBTeam = LOBTeam;
      state.LOBTeamAgent = LOBTeamAgent;
    },
    setLobTeamDataByLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLobTeamDataByAllLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      console.log(payload, 'payload');
      state.LOBTeamAgent = payload;
    },
    setAllLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    },
    changeDateRange: (state, action) => {
      state.rangeDate = action.payload;
    },
    setFieldsData: (state, action) => {
      state.fields = action.payload;
    },
    handleLobAllFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOB;
      state.LOB = state.LOB.map((obj) => ({ ...obj, value: !flag }));
      state.selected.LOB = state.LOB.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOB = !flag;
    },
    handleAllTeamFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeam;
      state.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeam = !flag;
    },

    handleAllAgentFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeamAgent;
      console.log();
      state.LOBTeamAgent = state.LOBTeamAgent.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.LOBTeamAgent = state.LOBTeamAgent.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeamAgent = !flag;
    },

    handleLobFilterChange: (state, action) => {
      const findIndex = state.LOB.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (findIndex !== -1) {
        if (!state.selected.LOB.includes(state.LOB[findIndex])) {
          state.selected.LOB[findIndex] = state.LOB[findIndex];
        }

        if (flag !== undefined) {
          if (!state.selected.LOB[findIndex]) {
            state.selected.LOB[findIndex] = {}; // Initialize if not defined
          }
          state.selected.LOB[findIndex].value = flag;
          if (!flag) state.selected.rowFilter.LOB = flag;
          else {
            const filtered = state.LOB.filter((item) => item.value === flag);
            if (state.LOB.length === filtered.length) {
              state.selected.rowFilter.LOB = flag;
            }
          }
        }

        if (!state.selected.rowFilter.LOB) {
          state.selected.rowFilter.LOBTeam = false;
        }
      }
    },
    handleTeamFilterChange: (state, action) => {
      // console.log(action.payload, 'letmecheck');
      state.ui.LOBTeam.flag = true;
      const flag = action.payload.value;
      const findIndex = state.LOBTeam.findIndex((item) => item.id === action.payload.id);
      if (findIndex !== -1) {
        if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
          state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
        }

        if (flag !== undefined) {
          if (!state.selected.LOBTeam[findIndex]) {
            state.selected.LOBTeam[findIndex] = {}; // Initialize if not defined
          }

          state.selected.LOBTeam[findIndex].value = flag;

          if (!flag) state.selected.rowFilter.LOBTeam = flag;
          else {
            const filtered = state.LOBTeam.filter((item) => item.value === flag);
            console.log(filtered, 'filtered');
            if (state.LOBTeam.length === filtered.length) {
              state.selected.rowFilter.LOBTeam = flag;
            }
          }
        }
        if (!state.selected.rowFilter.LOBTeam) {
          state.selected.rowFilter.LOBTeamAgent = false;
        }
      }
    },

    handleAgentFilterChange: (state, action) => {
      const findIndex = state.LOBTeamAgent.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
        state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
      }
      state.selected.LOBTeamAgent[findIndex].value = flag;
      if (!flag) state.selected.rowFilter.LOBTeamAgent = flag;
      else {
        const filtered = state.LOBTeamAgent.filter((item) => item.value === flag);
        if (state.LOBTeamAgent.length === filtered.length) {
          state.selected.rowFilter.LOBTeamAgent = flag;
        }
      }
      // state.LOBTeamAgent[findIndex].value = action.payload.value;
    },
    handleSetExtraFilterData: (state, action) => {
      console.log('action.payload.filter_type', action.payload);
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    handleRemoveExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = null;
    },

    handleSetMultipleExtraFilterData: (state, action) => {
      if (state.data.extra_filter[action.payload.filter_type].selected instanceof Array) {
        if (state.data.extra_filter[action.payload.filter_type].selected.includes(action.payload.value)) {
          const prevData = state.data.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
          // state.data.extra_filter[action.payload.filter_type].selected.pop(
          //   action.payload.value
          // );
        } else {
          state.data.extra_filter[action.payload.filter_type].selected.push(action.payload.value);
        }
      } else state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleRemoveMultipleExtraFilterData: (state, action) => {
      const prevData = state.data.extra_filter[action.payload.filter_type].selected;
      var index = prevData.indexOf(action.payload.value);
      if (index !== -1) {
        prevData.splice(index, 1);
      }
      // state.data.extra_filter[action.payload.filter_type].selected.pop(
      //   action.payload.value
      // );
    },
    handleRemoveMultipleExtraFilterDataFromApplied: (state, action) => {
      if (validateErrorAndCheckArray(state.extra_filter[action.payload.filter_type].selected)) {
        if (validateErrorAndCheckArray(action.payload.value)) {
          state.extra_filter[action.payload.filter_type].selected = null;
        } else {
          const prevData = state.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
        }
      } else {
        state.extra_filter[action.payload.filter_type].selected = null;
      }
      if (state.data.extra_filter) {
        state.data.extra_filter = state.extra_filter;
      }
    },
    handleRemoveMultipleAddcolumnFilterDataFromApplied: (state = initialState, action) => {
      let matchingFeatureKey;
      Object.entries(state.fields)?.map(([key, values]) => {
        console.log(key, values);
        const matchingFeature = values.find((_el) => _el.slug === action.payload.filter_type);

        if (matchingFeature) {
          matchingFeatureKey = key;
        }
      });
      if (matchingFeatureKey) {
        state.fields[matchingFeatureKey].forEach((item) => {
          if (item.slug === action.payload.filter_type) {
            item.selected = null;
          }
        });
      }
      // console.log(current(state.fields), 'dhgfgh');
    },
    handleSetMultipleFeatureFilterData: (state, action) => {
      const { filter_type, index, value } = action.payload;
      state.data.feature_filter[filter_type][index].selected = value;
    },
    handleRemoveFeatureExtraFilterData: (state, action) => {
      const { filter_type, index } = action.payload;

      state.data.feature_filter[filter_type][index].selected = null;
    },

    handleChangeAddtionalFields: (state, action) => {
      const { keyName, values, flag } = action.payload;

      if (!state.selected.fields.hasOwnProperty.call(keyName)) {
        state.selected.fields[keyName] = flag;
      } else {
        state.selected.fields[keyName] = flag;
      }

      Object.keys(values)?.map((item, index) => {
        state.fields[keyName][index].selected = flag;
      });
    },
    handleChangeAddtionalSubFields: (state, action) => {
      const { parentKey, flag, slug } = action.payload;
      if (!flag) state.selected.fields[parentKey] = flag;
      else {
        const original = Object.values(state.fields[parentKey]);
        const filtered = original.filter((item) => item.selected === flag);
        if (original.length === filtered.length) {
          state.selected.fields[parentKey] = flag;
        }
      }
      const finIndex = state.fields[parentKey]?.findIndex((_el) => _el?.slug === slug);
      state.fields[parentKey][finIndex].selected = flag;
    },

    // Feature Filter
    // Apply Button
    setFeatureFilter: (state) => {
      state.features_filter = state.data.feature_filter;
    },
    // Reset Button
    resetFeatureFilter: (state) => {
      state.features_filter = null;
    },

    // Advanced Filter
    // Apply Button
    setExtraFilter: (state) => {
      state.extra_filter = state.data.extra_filter;
    },
    // Reset Button
    resetExtraFilter: (state) => {
      state.extra_filter = null;
    },
    clearExtraFilter: (state) => {
      if (state.data.extra_filter) {
        Object.keys(state.data.extra_filter).forEach((key) => {
          state.data.extra_filter[key].selected = null;
        });
      }
    },
    clearLobTeamAgent: (state) => {
      const updatedLOB = state.LOB.map((item) => ({
        ...item,
        value: false
      }));
      state.LOB = updatedLOB;
      state.LOBTeam = [];
      state.LOBTeamAgent = [];
      state.selected.LOB = [];
      state.selected.LOBTeam = [];
      state.selected.LOBTeamAgent = [];
      // state.rangeDate = [];
      state.selected.rowFilter = initialState.selected.rowFilter;
    },
    onchangeSearch: (state, action) => {
      state.searchText = action.payload;
    },
    handlecloumnstore: (state, action) => {
      state.column = action.payload;
    }
  },

  extraReducers: {
    [getScoreCardConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getScoreCardConfigData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { data, ...others } = action.payload;
      state.ScoreCardFilterConfigData = others;
      state.LOB = others?.select_lob?.value;
      state.LOBTeam = !state.LOB ? others?.select_team?.value : [];
      state.LOBTeamAgent = !state.LOB && !state.LOBTeam ? others?.select_agent?.value : [];
      state.data = data;
      state.extra_filter = data?.extra_filter || {};
      state.rangeDate = others?.select_date?.value;
    },

    [getScoreCardConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getReportingTeamColumnData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getReportingTeamColumnData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      // Replace all Add Features groups with the team-scoped set. Guard against an empty
      // response so we never wipe the already-populated panel.
      if (action.payload && Object.keys(action.payload).length) {
        state.fields = action.payload;
      }
    },

    [getReportingTeamColumnData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
    // [getFiltersData.pending]: (state) => {
    //   state.status = 'init';
    //   state.ui.loading = true;
    // },

    // [getFiltersData.fulfilled]: (state, action) => {
    //   state.status = 'idle';
    //   state.ui.loading = false;
    //   state.data = { ...action.payload };
    // },

    // [getFiltersData.rejected]: (state, action) => {
    //   state.status = 'error';
    //   state.error = action.error.message;
    //   state.ui.loading = false;
    // }
  }
});

const {
  resetState,
  setSelectedDatafromParent,
  setFieldsData,
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleRemoveMultipleAddcolumnFilterDataFromApplied,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearExtraFilter,
  clearLobTeamAgent,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLobTeamDataByAllLob,
  setLOBTeamAgentDataByLobTeam,
  setAllLOBTeamAgentDataByLobTeam,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  setFeatureFilter,
  setExtraFilter,
  onchangeSearch,
  handlecloumnstore
} = filterSlice.actions;

export default filterSlice.reducer;

export {
  getFilterState,
  setSelectedDatafromParent,
  // getFiltersData,
  resetState,
  setFieldsData,
  setDefaultLobTeamAgent,
  changeDateRange,
  setLOBTeamAgentDataByLobTeam,
  setAllLOBTeamAgentDataByLobTeam,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  getScoreCardConfigData,
  setLobTeamDataByLob,
  setLobTeamDataByAllLob,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleRemoveMultipleAddcolumnFilterDataFromApplied,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  setFeatureFilter,
  setExtraFilter,
  clearExtraFilter,
  clearLobTeamAgent,
  onchangeSearch,
  handlecloumnstore,
  getReportingTeamColumnData
};
